import {pricingOnPDP} from '../../utils/constants/signalmanConstants';
export const pricingOnPDPTest = () => {
  return CustomInk.Metrics.fireEvent(
    'testing',
    '2024 04 30 pricing on pdp',
    `2024 04 30 pricing on pdp pricing_on_pdp_test_v6 ${pricingOnPDP}`
  );
};
